module.exports = "<app-navbar-admin></app-navbar-admin>\r\n<p>\r\n    admin works!\r\n</p>\r\n<!-- <router-outlet></router-outlet> -->"